import { render } from "./RecommendedAspectRatio.vue?vue&type=template&id=168982e8"
import script from "./RecommendedAspectRatio.vue?vue&type=script&lang=js"
export * from "./RecommendedAspectRatio.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "168982e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('168982e8', script)) {
    api.reload('168982e8', script)
  }
  
  module.hot.accept("./RecommendedAspectRatio.vue?vue&type=template&id=168982e8", () => {
    api.rerender('168982e8', render)
  })

}

script.__file = "resources/js/Pages/Media/RecommendedAspectRatio.vue"

export default script